import { render } from "./OrderDetail.vue?vue&type=template&id=05a0faa4&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"

import "./OrderDetail.vue?vue&type=style&index=0&id=05a0faa4&lang=css"
import "./OrderDetail.vue?vue&type=style&index=1&id=05a0faa4&lang=css"
import "./OrderDetail.vue?vue&type=style&index=2&id=05a0faa4&lang=css"
import "./OrderDetail.vue?vue&type=style&index=3&id=05a0faa4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a0faa4"]])

export default __exports__